export default __webpack_public_path__ + "static/media/WScoreIcon.a9784110.png";